export const ProductDetailBannerType = {
    Marketing: 'marketing',
    GiftWithPurchase: 'gwp',
    Fidelity: 'fidelity',
    BrandCorner: 'brand',
} as const;

export type ProductDetailBannerType = (typeof ProductDetailBannerType)[keyof typeof ProductDetailBannerType];
